import APIConfiguration from '@savgroup-front-common/configuration/src/api';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/src/shared';
import { BaseBackResponse } from '@savgroup-front-common/types';

import prepareResponseFailure from '../../helpers/prepareResponseFailure';
import { apiCall } from '../../services';

const ENDPOINT = `${APIConfiguration.carrier}carriers/label/${COMMON_QUERY_PARAMS.ID}/Downloaded`;

interface SetCarrierLabelDownloadedCommandArgs {
  carrierLabelId: string;
  downloaded: boolean;
}

async function setCarrierLabelDownloadedCommand({
  carrierLabelId,
  downloaded,
}: SetCarrierLabelDownloadedCommandArgs): Promise<BaseBackResponse> {
  try {
    const url = ENDPOINT.replace(COMMON_QUERY_PARAMS.ID, carrierLabelId);

    return await apiCall<BaseBackResponse>(url, {
      method: SUPPORTED_METHODS.POST,
      json: {
        downloaded,
      },
    });
  } catch (exception) {
    return prepareResponseFailure(exception);
  }
}

export default setCarrierLabelDownloadedCommand;
